import { render, staticRenderFns } from "./List.vue?vue&type=template&id=c6c2da30"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=c6c2da30&prod&lang=scss"
import style1 from "./List.vue?vue&type=style&index=1&id=c6c2da30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports